import React from 'react';
import { Path, Svg } from 'react-native-svg';
import type { IconProps } from './types';

export const NotificationPlusIcon: React.FC<IconProps> = ({
  size = 16,
  color = '#020202',
  style,
    ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 16 18"
    fill="none"
    overflow="visible"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
    style={[{ overflow: 'visible' } as const, style] as unknown}
  >
    <Path d="M5.55 14.0833V14.75C5.55 15.8546 6.42304 16.75 7.5 16.75C8.57695 16.75 9.45 15.8546 9.45 14.75V14.0833M4.9 8.08H7.50317M7.50317 8.08H10.1M7.50317 8.08V5.41667M7.50317 8.08V10.75M14 14.0833V7.25C14 3.66015 11.0899 0.75 7.5 0.75C3.91015 0.75 1 3.66015 1 7.25V14.0833H14Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </Svg>
);

NotificationPlusIcon.displayName = 'NotificationPlusIcon';
